import { useQuery } from "@tanstack/react-query";
import { fetchMetaAdsAdPreview, isMetaAdsApiConfigured } from "./useMetaAdsApi";

/**
 * Meta Marketing API ad preview (`GET /{ad-id}/previews`, mobile feed), proxied via meta-ads service.
 */
export function useMetaAdsAdPreview(adId, options = {}) {
  const { enabled = true, adFormat = "MOBILE_FEED_STANDARD" } = options;
  const id = String(adId || "").trim();
  const format =
    String(adFormat || "MOBILE_FEED_STANDARD")
      .trim()
      .toUpperCase() || "MOBILE_FEED_STANDARD";
  return useQuery({
    queryKey: ["meta-ads-ad-preview", id, format],
    queryFn: () => fetchMetaAdsAdPreview(id, format),
    enabled: Boolean(enabled && id && isMetaAdsApiConfigured()),
    staleTime: 20 * 60 * 1000,
  });
}
